import React from 'react';
import './BackButton.css';

export interface Props {
  onClick(): void;
}

export const BackButton = (props: Props) => {
  const { onClick } = props;

  return (
    <button className="back-button" onClick={onClick}>
      <i className="arrow-left" />
      Back
    </button>
  );
};
